/**
 * 定制客运通用状态存储
 * @type {{mutations: {}, state: {}, actions: {}}}
 */
const customtrans = {
  state: {
    // 价格方案生成状态
    priceMethodList: [],
    concatPriceMethodList: [],
    createSeateNumList: [], // 生成座位定价列表
    superPriceSeateNumList: [], // 超级组合
    superChildPriceSeateNumList: [],
    priceRuleParentList: [], // 超级组合的父亲列表
    runningPlanTimeForm: [], // 班次计划表
    carTypeList: [],
    priceMethodSelect: [],
  },
  mutations: {
    // 添加设置价格方案区间表
    ADD_SET_PRICE_METHOD_DATA(state, data) {
      state.priceMethodList.push(data)
    },
    UPDATE_PRICE_METHOD_DATA(state, data) {
      state.priceMethodList = data
    },
    COPY_ADD_SET_PRICE_METHOD_DATA(state, data) {
      state.concatPriceMethodList.push(data)
    },
    REMOVE_PRICE_METHOD_DATA(state) {
      state.priceMethodList = []
      state.concatPriceMethodList = []
    },

    // 添加座位定价
    ADD_SET_PRICE_SEATE_DATA(state, data) {
      state.createSeateNumList.push(data)
    },
    UPDATE_PRICE_SEATE_DATA(state, data) {
      state.createSeateNumList = data
    },
    REMOVE_SET_PRICESEATE_DATA(state) {
      state.createSeateNumList = []
    },

    // 超级组合父节点
    ADD_SUPER_PRICE_SEATE_DATA(state, data) {
      state.superPriceSeateNumList.push(data)
    },
    COPY_ADD_SUPER_PRICE_SEATE_DATA(state, data) {
      state.superChildPriceSeateNumList.push(data)
    },
    UPDATE_SUPER_PRICE_SEATE_DATA(state, data) {
      state.superPriceSeateNumList = data
    },
    REMOVE_SUPER_PRICE_SEATE_DATA(state) {
      state.superPriceSeateNumList = []
      state.superChildPriceSeateNumList = []
    },


    // 添加班次计划
    ADD_RUNNING_PLAN_FORM(state, data) {
      state.runningPlanTimeForm = data
    },
    UPDATE_RUNNING_PLAN_FORM(state, data) {
      state.runningPlanTimeForm = data
    },
    UPDATE_RUNNING_PLAN_FROM_INDE(state, { data, index }) {
      state.runningPlanTimeForm[index].carSeat = data.carSeat
      state.runningPlanTimeForm[index].carSeatName = data.carSeatName
      state.runningPlanTimeForm[index].carTypeName = data.carTypeName
      state.runningPlanTimeForm[index].carType = data.carType
      state.runningPlanTimeForm[index].priceMethodId = data.priceMethodId
      state.runningPlanTimeForm[index].priceMethodName = data.priceMethodName
    },
    REMOVE_RUNNING_PLAN_FORM(state) {
      state.runningPlanTimeForm = []
    },
    REMOVE_ROWP_PLAN_TIME(state, item) {
      state.runningPlanTimeForm.splice(state.runningPlanTimeForm.indexOf(item), 1)
    },
    UPDATE_PLAN_TIME_ROW_DRIVER(state, data) {
      state.runningPlanTimeForm[data.tableIndex] = data
    },
    UPDATE_PLAN_TIME_ROW_STATIONRULE(state, data) {
      state.runningPlanTimeForm[data.tableIndex] = data
    },

    ADD_CAR_TYPE_LIST(state, data) {
      state.carTypeList.push(data)
    },
    UPDATE_CAR_TYPE_LIST(state, data) {
      state.carTypeList = data
    },
    REMOVE_CAR_TYPE_LIST(state) {
      state.carTypeList = []
    },
    ADD_PRICE_METHOD_LIST(state, data) {
      state.priceMethodSelect.push(data)
    },
    UPDATE_PRICE_METHOD_LIST(state, data) {
      state.priceMethodSelect = data
    },
    REMOVE_PRICE_METHOD_LIST(state) {
      state.priceMethodSelect = []
    }
  },
  actions: {},
}
export default customtrans
